module.exports = __webpack_public_path__ + "img/crewing.84a68730.png";